import { WM_ENVIRONMENT } from "./config";

//stage
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  apiURL:
    WM_ENVIRONMENT === "development"
      ? "https://sapi.spiralbound.in/"
      : "https://api.spiralbound.in/",
  redirectURL:
    WM_ENVIRONMENT === "development"
      ? "https://test.spiralbound.in"
      : "https://spiralbound.in",
  publicURL:
    WM_ENVIRONMENT === "development"
      ? "https://test.spiralbound.in"
      : "https://spiralbound.in",
  identity: "wmhandler",
  test: WM_ENVIRONMENT === "development" ? "" : "",
};

// //production
// export default {
//   apiURL: "https://wisehandler.spiralbound.in/",
//   redirectURL: 'https://spiralbound.in',
//   publicURL: 'https://spiralbound.in',
//   identity: 'wmhandler',
// };
